import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withKeys as _withKeys, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = { class: "sidebar" }
const _hoisted_3 = { class: "nav-card" }
const _hoisted_4 = { class: "nav-logo" }
const _hoisted_5 = { class: "logo-icon" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "nav-list" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  class: "nav-menu-visual",
  "aria-hidden": "true"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  class: "history-tabs",
  "aria-label": "内容分类"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "history-toolbar" }
const _hoisted_14 = {
  class: "type-tabs",
  "aria-label": "内容类型"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["aria-label"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "audio-history-icon" }
const _hoisted_19 = { class: "audio-history-copy" }
const _hoisted_20 = { class: "audio-history-title" }
const _hoisted_21 = { class: "audio-history-date" }
const _hoisted_22 = {
  key: 0,
  class: "select-mark audio-select-mark"
}
const _hoisted_23 = ["aria-label", "onClick", "onKeydown"]
const _hoisted_24 = ["src", "poster", "onClick", "onPlay", "onPause", "onEnded"]
const _hoisted_25 = {
  key: 0,
  class: "tpr-history-video-status",
  "aria-hidden": "true"
}
const _hoisted_26 = {
  key: 1,
  class: "select-mark"
}
const _hoisted_27 = { class: "content-title" }
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 2,
  class: "select-mark"
}
const _hoisted_30 = { class: "content-title" }
const _hoisted_31 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_32 = {
  key: 3,
  class: "favorite-loading-state"
}
const _hoisted_33 = {
  key: 0,
  class: "batch-actions"
}
const _hoisted_34 = ["disabled"]
const _hoisted_35 = {
  key: 0,
  class: "history-audio-player-dock",
  "aria-label": "音频播放器"
}
const _hoisted_36 = { class: "history-audio-player-copy" }
const _hoisted_37 = { class: "history-audio-player-title" }
const _hoisted_38 = ["src"]

import logo2Image from '../assets/logo2.png'
import menuBgImage from '../assets/menu_bg.jpg'
import ParentPasswordModal from '../components/ParentPasswordModal.vue'
import { computed, ref, watch, onMounted, onUnmounted, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getFavoritesPage, batchDeleteFavorites, type FavoritesVO } from '@/api/favorites'
import { deleteHistory, getHistoryPage, type HistoryVO } from '@/api/history'
import { getTprList, type TprVO } from '@/api/course-tpr'

const AUTH_STORAGE_KEY = 'tree-sprout-auth'
const PARENT_VERIFIED_STORAGE_KEY = 'tree-sprout-parent-verified'

type ApiListItem = HistoryVO | FavoritesVO | Record<string, any>


export default /*@__PURE__*/_defineComponent({
  __name: 'history',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const tabs = [
  { id: 'history', label: '历史' },
  { id: 'favorites', label: '收藏' },
]

const typeOptions = [
  { id: 'video', label: '视频' },
  { id: 'audio', label: '音频' },
  { id: 'card', label: 'TPR' },
  { id: 'word', label: '单词' },
]

const queryParams = ref({
  pageNo: 1,
  pageSize: 12,
  contentType: 1
})

const favoritesList = ref<FavoritesVO[]>([])
const historyList = ref<HistoryVO[]>([])
const dataTotal = ref(0)
const isLoading = ref(false)
const tprDetailMap = ref<Record<string, TprVO>>({})
const loadedTprDetailKeys = new Set<string>()

const getFavoriteVideoItemId = (item: FavoritesVO) => item.id
const getHistoryVideoItemId = (item: HistoryVO) => item.id

const getContentTypeByType = (typeId) => {
  if (typeId === 'audio') {
    return 2
  }

  if (typeId === 'card') {
    return 3
  }

  if (typeId === 'word') {
    return 4
  }

  return 1
}

const syncQueryContentType = () => {
  queryParams.value.contentType = getContentTypeByType(activeType.value)
}

const normalizeId = (id) => id === undefined || id === null ? '' : String(id)

const getApiItemContent = (item: ApiListItem) => {
  return item.content ||
    item.contentInfo ||
    item.detail ||
    item.wordSeries ||
    item.wordSeriesVO ||
    item.courseWordSeries ||
    item.courseWordSeriesVO ||
    item.tpr ||
    item.courseTpr ||
    item.courseTprDO ||
    item.courseTprVO ||
    item.resource ||
    {}
}

const getApiItemCachedTpr = (item: ApiListItem) => {
  const content = getApiItemContent(item)
  const contentId = normalizeId(item.contentId ?? content.id)
  return contentId ? tprDetailMap.value[contentId] || null : null
}

const getApiItemSeriesId = (item: ApiListItem) => {
  const content = getApiItemContent(item)
  return normalizeId(item.seriesId || item.contentId || content.seriesId || content.id)
}

const getApiItemField = (item: ApiListItem, key: string) => {
  const content = getApiItemContent(item)
  const cachedTpr = getApiItemCachedTpr(item)
  return item[key] || content[key] || cachedTpr?.[key] || ''
}

const getApiItemTitle = (item: HistoryVO | FavoritesVO) => {
  if (activeType.value === 'card') {
    const english = getApiItemField(item, 'english')
    const chinese = getApiItemField(item, 'chinese')
    const name = getApiItemField(item, 'name')
    return [english, chinese].filter(Boolean).join(' / ') || name || 'TPR'
  }

  if (activeType.value === 'word') {
    return getApiItemField(item, 'name') ||
      getApiItemField(item, 'title') ||
      getApiItemField(item, 'seriesName') ||
      getApiItemField(item, 'wordSeriesName') ||
      '单词闪卡'
  }

  return getApiItemField(item, 'name') || getApiItemField(item, 'english') || getApiItemField(item, 'chinese') || ''
}

const getApiItemVideoUrl = (item: HistoryVO | FavoritesVO) => getApiItemField(item, 'videoUrl')
const getApiItemCoverUrl = (item: HistoryVO | FavoritesVO) => getApiItemField(item, 'coverUrl')
const getApiItemPlayId = (item: HistoryVO | FavoritesVO) => normalizeId(item.contentId || getApiItemContent(item).id || item.id)

const favoriteVideoItems = computed(() => {
  return favoritesList.value.map((item) => ({
    id: getFavoriteVideoItemId(item),
    playId: getApiItemPlayId(item),
    tab: 'favorites',
    type: activeType.value,
    title: getApiItemTitle(item),
    contentId: item.contentId,
    seriesId: item.seriesId || item.contentId,
    seasonId: item.seasonId,
    category: getApiItemField(item, 'category'),
    chinese: getApiItemField(item, 'chinese'),
    english: getApiItemField(item, 'english'),
    date: item.createTime,
    audioUrl: getApiItemField(item, 'audioUrl'),
    videoUrl: getApiItemVideoUrl(item),
    coverUrl: getApiItemCoverUrl(item),
    coverStart: '#e8e8e8',
    coverEnd: '#d9d9d9',
  }))
})

const historyVideoItems = computed(() => {
  return historyList.value.map((item) => ({
    id: getHistoryVideoItemId(item),
    playId: getApiItemPlayId(item),
    tab: 'history',
    type: activeType.value,
    title: getApiItemTitle(item),
    contentId: item.contentId,
    seriesId: item.seriesId || item.contentId,
    seasonId: item.seasonId,
    category: getApiItemField(item, 'category'),
    chinese: getApiItemField(item, 'chinese'),
    english: getApiItemField(item, 'english'),
    date: item.createTime,
    audioUrl: getApiItemField(item, 'audioUrl'),
    videoUrl: getApiItemVideoUrl(item),
    coverUrl: getApiItemCoverUrl(item),
    coverStart: '#e8e8e8',
    coverEnd: '#d9d9d9',
  }))
})

const contentItems = ref([
  {
    id: 'history-video-1',
    tab: 'history',
    type: 'video',
    title: 'yakka dee 第一季 01 Banana',
    season: 's1',
    episode: 's1-1',
    coverStart: '#e8e8e8',
    coverEnd: '#d9d9d9',
  },
  {
    id: 'history-video-2',
    tab: 'history',
    type: 'video',
    title: 'yakka dee 第二季 01 Banana',
    season: 's2',
    episode: 's2-1',
    coverStart: '#e5e5e5',
    coverEnd: '#d7d7d7',
  },
  {
    id: 'history-video-3',
    tab: 'history',
    type: 'video',
    title: 'SSS-唱跳儿歌(TPR)',
    coverStart: '#e7e7e7',
    coverEnd: '#d8d8d8',
  },
  {
    id: 'history-video-4',
    tab: 'history',
    type: 'video',
    title: 'Super Simple Songs',
    coverStart: '#e4e4e4',
    coverEnd: '#d6d6d6',
  },
  {
    id: 'favorites-video-1',
    tab: 'favorites',
    type: 'video',
    title: 'Peppa Pig English',
    coverStart: '#e8e8e8',
    coverEnd: '#d9d9d9',
  },
  {
    id: 'favorites-video-2',
    tab: 'favorites',
    type: 'video',
    title: 'Alphablocks',
    coverStart: '#e5e5e5',
    coverEnd: '#d7d7d7',
  },
  {
    id: 'history-card-1',
    tab: 'history',
    type: 'card',
    title: 'TPR词卡 身体指令',
    coverStart: '#e8f4ff',
    coverEnd: '#d4e8ff',
  },
  {
    id: 'history-card-2',
    tab: 'history',
    type: 'card',
    title: 'TPR词卡 日常生活',
    coverStart: '#fff0df',
    coverEnd: '#ffe2c5',
  },
  {
    id: 'history-card-3',
    tab: 'history',
    type: 'card',
    title: '单词闪卡 26个英文字母',
    coverStart: '#e8f4ff',
    coverEnd: '#ffe2c5',
  },
  {
    id: 'favorites-card-1',
    tab: 'favorites',
    type: 'card',
    title: '动物主题词卡',
    coverStart: '#e8f5e9',
    coverEnd: '#c8e6c9',
  },
  {
    id: 'history-audio-1',
    tab: 'history',
    type: 'audio',
    title: 'Good Morning Song 晨间律动儿歌',
    date: '2026-05-02',
    coverStart: '#fff5d8',
    coverEnd: '#ffe3a3',
  },
  {
    id: 'history-audio-2',
    tab: 'history',
    type: 'audio',
    title: '日常英语听力',
    date: '2026-04-28',
    coverStart: '#e8f7ff',
    coverEnd: '#c7ebff',
  },
  {
    id: 'favorites-audio-1',
    tab: 'favorites',
    type: 'audio',
    title: '晚安英文儿歌',
    date: '2026-04-18',
    coverStart: '#fff0df',
    coverEnd: '#ffd6bc',
  },
  {
    id: 'history-word-1',
    tab: 'history',
    type: 'word',
    title: '26个英文字母',
    coverStart: '#e8f4ff',
    coverEnd: '#d4e8ff',
  },
  {
    id: 'history-word-2',
    tab: 'history',
    type: 'word',
    title: '基础单词闪卡',
    coverStart: '#f2e8ff',
    coverEnd: '#dfc9ff',
  },
  {
    id: 'favorites-word-1',
    tab: 'favorites',
    type: 'word',
    title: '动物单词收藏',
    coverStart: '#e8f5e9',
    coverEnd: '#c8e6c9',
  },
])

const getRouteTab = () => {
  const tab = route.query.tab

  if (tab === 'favorites') {
    return 'favorites'
  }

  return 'history'
}

const getRouteType = () => {
  const type = route.query.type

  if (typeOptions.some((option) => option.id === type)) {
    return type
  }

  return 'video'
}

const getHistoryRouteQuery = (tabId, typeId) => {
  return {
    tab: tabId,
    type: typeId,
  }
}

const activeTab = ref(getRouteTab())
const activeType = ref(getRouteType())
const isEditing = ref(false)
const selectedIds = ref([])
const currentAudioItemId = ref('')
const currentAudioSrc = ref('')
const currentTprItemId = ref('')
const audioPlayerRef = ref(null)
const parentPasswordModalRef = ref(null)
const historyShellRef = ref<HTMLElement | null>(null)
const tprVideoRefs = new Map()
let historyScrollContainer: HTMLElement | null = null
const activeNav = computed(() => activeTab.value === 'favorites' ? 'favorites' : 'history')
const navItems = [
  { id: 'home', label: '首页', icon: 'home' },
  { id: 'history', label: '观看历史', icon: 'play-circle' },
  { id: 'favorites', label: '宝贝收藏', icon: 'heart' },
  { id: 'settings', label: '偏好设置', icon: 'cog' },
  { id: 'parent', label: '家长模式', icon: 'user-shield' },
]


const currentTabLabel = computed(() => {
  return tabs.find((tab) => tab.id === activeTab.value)?.label || '历史'
})

const visibleItems = computed(() => {
  if (activeTab.value === 'history' && isApiListView.value) {
    return historyVideoItems.value
  }

  if (activeTab.value === 'favorites' && isApiListView.value) {
    return favoriteVideoItems.value
  }

  return contentItems.value.filter((item) => item.tab === activeTab.value && item.type === activeType.value)
})

const currentAudioItem = computed(() => {
  return visibleItems.value.find((item) => item.id === currentAudioItemId.value) || null
})

const hasSelectedItems = computed(() => selectedIds.value.length > 0)
const dataTotalPages = computed(() => Math.ceil(dataTotal.value / queryParams.value.pageSize))
const hasNextVideoPage = computed(() => queryParams.value.pageNo < dataTotalPages.value)
const isVideoListView = computed(() => (activeTab.value === 'history' || activeTab.value === 'favorites') && activeType.value === 'video')
const isApiListView = computed(() => (activeTab.value === 'history' || activeTab.value === 'favorites') && ['video', 'audio', 'card', 'word'].includes(activeType.value))
const currentVideoList = computed(() => activeTab.value === 'favorites' ? favoritesList.value : historyList.value)
const showVideoSkeleton = computed(() => isApiListView.value && isLoading.value && currentVideoList.value.length === 0)
const isVideoPageLoading = computed(() => isApiListView.value && isLoading.value && currentVideoList.value.length > 0)

const selectTab = (tabId) => {
  activeTab.value = tabId
  selectedIds.value = []
  router.replace({
    path: '/history',
    query: getHistoryRouteQuery(tabId, activeType.value),
  })
}

const selectType = (typeId) => {
  activeType.value = typeId
  selectedIds.value = []
  resetVideoQuery()
  syncQueryContentType()
  router.replace({
    path: '/history',
    query: getHistoryRouteQuery(activeTab.value, typeId),
  })
  if (isApiListView.value) {
    loadVideoList()
  }
}

const toggleEditing = () => {
  isEditing.value = !isEditing.value

  if (!isEditing.value) {
    selectedIds.value = []
  }
}

const selectAllVisibleItems = () => {
  selectedIds.value = visibleItems.value.map((item) => item.id)
}

const finishEditingAfterDelete = () => {
  selectedIds.value = []
  isEditing.value = false
}

const deleteSelectedItems = () => {
  if (!hasSelectedItems.value) {
    return
  }
  const selectedSet = new Set(selectedIds.value)
  const isPlayingTprSelected = visibleItems.value.some((item) => {
    const playId = item.playId || item.contentId || item.id
    return selectedSet.has(item.id) && playId === currentTprItemId.value
  })

  if (activeTab.value === 'history' && isApiListView.value) {
    deleteHistory(selectedIds.value)
    const selectedCount = historyList.value.filter((item) => selectedSet.has(getHistoryVideoItemId(item))).length
    historyList.value = historyList.value.filter((item) => !selectedSet.has(getHistoryVideoItemId(item)))
    dataTotal.value = Math.max(0, dataTotal.value - selectedCount)
    if (isPlayingTprSelected) {
      pauseAllTprVideos()
      currentTprItemId.value = ''
    }
    finishEditingAfterDelete()
    return
  }

  if (activeTab.value === 'favorites' && isApiListView.value) {
    batchDeleteFavorites(selectedIds.value)
    const selectedCount = favoritesList.value.filter((item) => selectedSet.has(getFavoriteVideoItemId(item))).length
    favoritesList.value = favoritesList.value.filter((item) => !selectedSet.has(getFavoriteVideoItemId(item)))
    dataTotal.value = Math.max(0, dataTotal.value - selectedCount)
    if (isPlayingTprSelected) {
      pauseAllTprVideos()
      currentTprItemId.value = ''
    }
    finishEditingAfterDelete()
    return
  }

  contentItems.value = contentItems.value.filter((item) => !selectedSet.has(item.id))
  if (selectedSet.has(currentAudioItemId.value)) {
    currentAudioItemId.value = ''
  }
  if (isPlayingTprSelected) {
    pauseAllTprVideos()
    currentTprItemId.value = ''
  }
  finishEditingAfterDelete()
}

const handleGoBack = () => {
  router.push({
    path: '/',
    query: {
      tab: 'profile',
    },
  })
}

const openParentPasswordModal = () => {
  parentPasswordModalRef.value?.open()
}

const handleNavItemClick = (item) => {
  if (item.id === 'home') {
    router.push('/')
    return
  }

  if (item.id === 'parent') {
    openParentPasswordModal()
    return
  }

  if (item.id === 'settings') {
    router.push('/preference')
    return
  }

  if (item.id === 'history' || item.id === 'favorites') {
    router.push({
      path: '/history',
      query: item.id === 'favorites' ? { tab: 'favorites', type: activeType.value } : { tab: 'history', type: activeType.value }
    })
  }
}

const handleCardClick = (item) => {
  if (isEditing.value) {
    selectedIds.value = selectedIds.value.includes(item.id)
      ? selectedIds.value.filter((id) => id !== item.id)
      : [...selectedIds.value, item.id]
    return
  }

  if (item.type === 'video') {
    if (item.seriesId) {
      router.push({
        path: '/player',
        query: {
          seriesId: item.seriesId,
          seasonId: item.seasonId,
          episodesId: item.contentId,
        },
      })
      return
    }

    router.push({
      path: '/play',
      query: item.season && item.episode ? { season: item.season, episode: item.episode } : {},
    })
    return
  }

  if (item.type === 'card') {
    playTprItem(item)
    return
  }

  if (item.type === 'audio') {
    playAudioItem(item)
    return
  }

  if (item.type === 'word') {
    const seriesId = item.seriesId || item.contentId
    router.push({
      path: '/word',
      query: seriesId ? { seriesId } : {}
    })
  }
}

const playAudioItem = async (item) => {
  currentAudioItemId.value = item.id
  currentAudioSrc.value = item.audioUrl || ''
  pauseAllTprVideos()
  currentTprItemId.value = ''

  await Promise.resolve()

  if (!audioPlayerRef.value || !currentAudioSrc.value) {
    return
  }

  audioPlayerRef.value.currentTime = 0
  audioPlayerRef.value.play().catch(() => {})
}

const handleAudioEnded = () => {
  currentAudioItemId.value = ''
}

const setTprVideoRef = (cardId, el) => {
  const normalizedCardId = normalizeId(cardId)

  if (el instanceof HTMLVideoElement) {
    tprVideoRefs.set(normalizedCardId, el)
    return
  }

  tprVideoRefs.delete(normalizedCardId)
}

const playVideo = async (video, restart = false) => {
  if (!video) {
    return
  }

  if (restart) {
    video.currentTime = 0
  }

  try {
    await video.play()
  } catch {
    // Browser autoplay rules can block playback; the card state stays usable.
  }
}

const pauseAllTprVideos = (exceptId = null) => {
  const normalizedExceptId = normalizeId(exceptId)

  tprVideoRefs.forEach((video, cardId) => {
    if (!video || cardId === normalizedExceptId) {
      return
    }

    video.pause()
    video.currentTime = 0
  })
}

const getTprRequestBaseParams = () => {
  return route.query.stage ? { stage: route.query.stage } : {}
}

const mergeTprDetails = (list: TprVO[] = []) => {
  const nextMap = { ...tprDetailMap.value }

  list.forEach((item) => {
    const itemId = normalizeId(item.id)
    if (itemId) {
      nextMap[itemId] = item
    }
  })

  tprDetailMap.value = nextMap
}

const loadAllTprDetails = async () => {
  const cacheKey = normalizeId(route.query.stage || 'all')
  if (loadedTprDetailKeys.has(cacheKey)) {
    return
  }

  const baseParams = getTprRequestBaseParams()
  const categories = [
    '\u8eab\u4f53\u6307\u4ee4',
    '\u65e5\u5e38\u751f\u6d3b',
    '\u60c5\u7eea\u611f\u53d7'
  ]

  const results = await Promise.allSettled([
    getTprList(baseParams),
    ...categories.map((category) => getTprList({ ...baseParams, category }))
  ])

  results.forEach((result) => {
    if (result.status === 'fulfilled') {
      mergeTprDetails(result.value || [])
    }
  })

  loadedTprDetailKeys.add(cacheKey)
}

const preloadTprDetailsForItems = async (list: ApiListItem[]) => {
  if (activeType.value !== 'card' || list.length === 0) {
    return
  }

  const hasMissingVideo = list.some((item) => !getApiItemVideoUrl(item))
  if (hasMissingVideo) {
    await loadAllTprDetails()
  }
}

const preloadApiDetailsForItems = async (list: ApiListItem[]) => {
  await preloadTprDetailsForItems(list)
}

const resolveTprPlayableItem = (item) => {
  const contentId = normalizeId(item.contentId || item.playId || item.id)
  const cachedTpr = contentId ? tprDetailMap.value[contentId] : null

  if (!cachedTpr) {
    return item
  }

  return {
    ...item,
    title: item.title || [cachedTpr.english, cachedTpr.chinese].filter(Boolean).join(' / ') || 'TPR',
    videoUrl: item.videoUrl || cachedTpr.videoUrl || '',
    coverUrl: item.coverUrl || cachedTpr.coverUrl || '',
  }
}

const playTprItem = async (item, restart = true) => {
  let playableItem = resolveTprPlayableItem(item)

  if (!playableItem.videoUrl) {
    await loadAllTprDetails()
    await nextTick()
    playableItem = resolveTprPlayableItem(item)
  }

  if (!playableItem.videoUrl) {
    return
  }

  const playId = normalizeId(playableItem.playId || playableItem.contentId || playableItem.id)
  let video = tprVideoRefs.get(playId)
  if (!video) {
    await nextTick()
    video = tprVideoRefs.get(playId)
  }

  if (!video) {
    return
  }

  if (video.getAttribute('src') !== playableItem.videoUrl) {
    video.src = playableItem.videoUrl
    video.load()
  }

  if (currentTprItemId.value === playId && !video.paused && !video.ended) {
    video.pause()
    return
  }

  currentTprItemId.value = playId
  currentAudioItemId.value = ''
  currentAudioSrc.value = ''
  pauseAllTprVideos(playId)

  await playVideo(video, restart)
}

const handleTprVideoElementClick = (item) => {
  const playId = normalizeId(item.playId || item.contentId || item.id)
  const video = tprVideoRefs.get(playId)
  if (!video) {
    return
  }

  if (currentTprItemId.value !== playId) {
    handleCardClick(item)
  }
}

const handleTprVideoPlay = (cardId) => {
  currentTprItemId.value = normalizeId(cardId)
  currentAudioItemId.value = ''
  currentAudioSrc.value = ''
  pauseAllTprVideos(currentTprItemId.value)
}

const handleTprVideoPause = (cardId) => {
  if (currentTprItemId.value === normalizeId(cardId)) {
    currentTprItemId.value = ''
  }
}

const handleTprVideoEnded = (cardId) => {
  if (currentTprItemId.value === normalizeId(cardId)) {
    currentTprItemId.value = ''
  }
}

const isPageNearBottom = () => {
  const scrollContainer = historyShellRef.value

  if (scrollContainer && scrollContainer.scrollHeight > scrollContainer.clientHeight + 1) {
    return scrollContainer.scrollTop + scrollContainer.clientHeight >= scrollContainer.scrollHeight - 120
  }

  const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight
  const pageHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight)

  return scrollTop + viewportHeight >= pageHeight - 120
}

const loadNextVideoPage = async () => {
  if (!isApiListView.value || isLoading.value || !hasNextVideoPage.value) {
    return
  }

  queryParams.value.pageNo += 1
  await loadVideoList(true)
}

const handlePageScroll = () => {
  if (isPageNearBottom()) {
    loadNextVideoPage()
  }
}

const resetVideoQuery = () => {
  queryParams.value.pageNo = 1
  dataTotal.value = 0
  historyList.value = []
  favoritesList.value = []
}

const loadVideoList = async (append = false) => {
  if (!isApiListView.value) {
    return
  }

  if (activeTab.value === 'favorites') {
    await getFavoriteList(append)
    return
  }

  await getHistoryList(append)
}

watch(
  () => [route.query.tab, route.query.type],
  () => {
    activeTab.value = getRouteTab()
    activeType.value = getRouteType()
    selectedIds.value = []
    resetVideoQuery()
    syncQueryContentType()
    if (isApiListView.value) {
      loadVideoList()
    }
  }
)

watch(activeType, () => {
  selectedIds.value = []
  if (activeType.value !== 'audio') {
    currentAudioItemId.value = ''
    currentAudioSrc.value = ''
  }
  if (activeType.value !== 'card') {
    pauseAllTprVideos()
    currentTprItemId.value = ''
  }
})

onMounted(async () => {
  syncQueryContentType()
  loadVideoList()
  historyScrollContainer = historyShellRef.value
  window.addEventListener('scroll', handlePageScroll, { passive: true })
  historyScrollContainer?.addEventListener('scroll', handlePageScroll, { passive: true })
})

onUnmounted(() => {
  window.removeEventListener('scroll', handlePageScroll)
  historyScrollContainer?.removeEventListener('scroll', handlePageScroll)
  historyScrollContainer = null
  pauseAllTprVideos()
})

const getFavoriteList = async (append = false) => {
  if (isLoading.value) {
    return
  }

  isLoading.value = true
  try {
    const data = await getFavoritesPage(queryParams.value)
    const list = data?.list || []
    await preloadApiDetailsForItems(list)
    favoritesList.value = append ? [...favoritesList.value, ...list] : list
    dataTotal.value = data?.total || 0
  } catch {
    if (append) {
      queryParams.value.pageNo = Math.max(1, queryParams.value.pageNo - 1)
    }
  } finally {
    isLoading.value = false
  }
}

const getHistoryList = async (append = false) => {
  if (isLoading.value) {
    return
  }

  isLoading.value = true
  try {
    const data = await getHistoryPage(queryParams.value)
    const list = data?.list || []
    await preloadApiDetailsForItems(list)
    historyList.value = append ? [...historyList.value, ...list] : list
    dataTotal.value = data?.total || 0
  } catch {
    if (append) {
      queryParams.value.pageNo = Math.max(1, queryParams.value.pageNo - 1)
    }
  } finally {
    isLoading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["history-page", { editing: isEditing.value }])
  }, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "bg-decoration" }, [
      _createElementVNode("div", { class: "orb orb-1" }),
      _createElementVNode("div", { class: "orb orb-2" }),
      _createElementVNode("div", { class: "orb orb-3" })
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("aside", _hoisted_2, [
        _createElementVNode("nav", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: _unref(logo2Image),
                alt: "",
                class: "logo2-icon"
              }, null, 8, _hoisted_6)
            ]),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "brand-copy" }, [
              _createElementVNode("h1", { class: "brand-name" }, "树苗英语"),
              _createElementVNode("span", { class: "brand-subtitle" }, "TREE SAPLING")
            ], -1))
          ]),
          _createElementVNode("ul", _hoisted_7, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item) => {
              return _createElementVNode("li", {
                key: item.id
              }, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _withModifiers(($event: any) => (handleNavItemClick(item)), ["prevent"]),
                  class: _normalizeClass(['nav-item', { active: activeNav.value === item.id }])
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: item.icon,
                    class: "nav-icon"
                  }, null, 8, ["icon"]),
                  _createElementVNode("span", null, _toDisplayString(item.label), 1)
                ], 10, _hoisted_8)
              ])
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("img", {
              src: _unref(menuBgImage),
              alt: "",
              class: "nav-menu-image"
            }, null, 8, _hoisted_10)
          ])
        ])
      ]),
      _createElementVNode("main", {
        ref_key: "historyShellRef",
        ref: historyShellRef,
        class: "history-shell"
      }, [
        _createElementVNode("header", _hoisted_11, [
          _createElementVNode("button", {
            type: "button",
            class: "mobile-back-btn",
            onClick: handleGoBack,
            "aria-label": "返回上一页"
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "chevron-left" })
          ]),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
            return _createElementVNode("button", {
              key: tab.id,
              type: "button",
              class: _normalizeClass(["history-tab", { active: activeTab.value === tab.id }]),
              onClick: ($event: any) => (selectTab(tab.id))
            }, _toDisplayString(tab.label), 11, _hoisted_12)
          }), 64))
        ]),
        _createElementVNode("section", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(typeOptions, (type) => {
              return _createElementVNode("button", {
                key: type.id,
                type: "button",
                class: _normalizeClass(["type-tab", { active: activeType.value === type.id }]),
                onClick: ($event: any) => (selectType(type.id))
              }, _toDisplayString(type.label), 11, _hoisted_15)
            }), 64))
          ]),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["edit-btn", { active: isEditing.value }]),
            onClick: toggleEditing
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: isEditing.value ? 'xmark' : 'pen-to-square'
            }, null, 8, ["icon"]),
            _createElementVNode("span", null, _toDisplayString(isEditing.value ? '取消' : '编辑'), 1)
          ], 2)
        ]),
        _createElementVNode("section", {
          class: _normalizeClass(["content-grid", `type-${activeType.value}`]),
          "aria-label": currentTabLabel.value
        }, [
          (showVideoSkeleton.value)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(queryParams.value.pageSize, (index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `video-skeleton-${index}`,
                  class: "content-card skeleton-card"
                }, [
                  _createVNode(_component_el_skeleton, { animated: "" }, {
                    template: _withCtx(() => [
                      _createVNode(_component_el_skeleton_item, {
                        variant: "image",
                        class: "skeleton-cover"
                      }),
                      _createVNode(_component_el_skeleton_item, {
                        variant: "text",
                        class: "skeleton-title"
                      })
                    ]),
                    _: 1
                  })
                ]))
              }), 128))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(visibleItems.value, (item) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: item.id,
                  class: _normalizeClass(["content-card", [
                `content-card-${item.type}`,
                {
                  selected: selectedIds.value.includes(item.id),
                  editing: isEditing.value,
                  playing: currentAudioItemId.value === item.id || currentTprItemId.value === item.playId
                }
              ]]),
                  onClick: ($event: any) => (handleCardClick(item))
                }, [
                  (item.type === 'audio')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: currentAudioItemId.value === item.id ? 'volume-high' : 'headphones'
                          }, null, 8, ["icon"])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("h2", _hoisted_20, _toDisplayString(item.title), 1),
                          _createElementVNode("p", _hoisted_21, _toDisplayString(item.date), 1)
                        ]),
                        (isEditing.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                              (selectedIds.value.includes(item.id))
                                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                    key: 0,
                                    icon: "check"
                                  }))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (item.type === 'card')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", {
                            class: "tpr-history-surface",
                            "aria-label": `播放 ${item.title}`,
                            role: "button",
                            tabindex: "0",
                            onClick: _withModifiers(($event: any) => (handleCardClick(item)), ["stop"]),
                            onKeydown: [
                              _withKeys(_withModifiers(($event: any) => (handleCardClick(item)), ["prevent"]), ["enter"]),
                              _withKeys(_withModifiers(($event: any) => (handleCardClick(item)), ["prevent"]), ["space"])
                            ]
                          }, [
                            _createElementVNode("div", {
                              class: "tpr-history-video-wrap",
                              style: _normalizeStyle({ '--cover-start': item.coverStart, '--cover-end': item.coverEnd })
                            }, [
                              _createElementVNode("video", {
                                ref_for: true,
                                ref: (el) => setTprVideoRef(item.playId, el),
                                class: _normalizeClass(["tpr-history-video", { active: currentTprItemId.value === item.playId }]),
                                src: item.videoUrl,
                                poster: item.coverUrl,
                                playsinline: "",
                                preload: "auto",
                                controlslist: "nodownload nofullscreen noremoteplayback",
                                disablepictureinpicture: "",
                                onClick: _withModifiers(($event: any) => (handleTprVideoElementClick(item)), ["stop"]),
                                onPlay: ($event: any) => (handleTprVideoPlay(item.playId)),
                                onPause: ($event: any) => (handleTprVideoPause(item.playId)),
                                onEnded: ($event: any) => (handleTprVideoEnded(item.playId))
                              }, null, 42, _hoisted_24),
                              (currentTprItemId.value !== item.playId && item.videoUrl)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    _createVNode(_component_font_awesome_icon, { icon: "play" })
                                  ]))
                                : _createCommentVNode("", true),
                              (isEditing.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                    (selectedIds.value.includes(item.id))
                                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                          key: 0,
                                          icon: "check"
                                        }))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 4)
                          ], 40, _hoisted_23),
                          _createElementVNode("h2", _hoisted_27, _toDisplayString(item.title), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["cover-box", { 'has-cover': item.coverUrl }]),
                            style: _normalizeStyle({ '--cover-start': item.coverStart, '--cover-end': item.coverEnd })
                          }, [
                            (item.coverUrl)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: item.coverUrl,
                                  alt: "",
                                  class: "cover-image"
                                }, null, 8, _hoisted_28))
                              : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                  key: 1,
                                  icon: "image",
                                  class: "cover-icon"
                                })),
                            (isEditing.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                                  (selectedIds.value.includes(item.id))
                                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                        key: 0,
                                        icon: "check"
                                      }))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 6),
                          _createElementVNode("h2", _hoisted_30, _toDisplayString(item.title), 1)
                        ], 64))
                ], 10, _hoisted_17))
              }), 128)),
          (!showVideoSkeleton.value && visibleItems.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createVNode(_component_font_awesome_icon, {
                  icon: activeTab.value === 'history' ? 'clock-rotate-left' : 'heart'
                }, null, 8, ["icon"]),
                _createElementVNode("p", null, _toDisplayString(activeTab.value === 'history' ? '暂无观看历史' : '暂无收藏内容'), 1)
              ]))
            : _createCommentVNode("", true),
          (isVideoPageLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createVNode(_component_el_skeleton, { animated: "" }, {
                  template: _withCtx(() => [
                    _createVNode(_component_el_skeleton_item, {
                      variant: "text",
                      class: "favorite-loading-line"
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ], 10, _hoisted_16)
      ], 512)
    ]),
    _createVNode(_Transition, { name: "batch-bar" }, {
      default: _withCtx(() => [
        (isEditing.value)
          ? (_openBlock(), _createElementBlock("footer", _hoisted_33, [
              _createElementVNode("button", {
                type: "button",
                class: "batch-btn select-all-btn",
                onClick: selectAllVisibleItems
              }, " 全选 "),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["batch-btn delete-btn", { active: hasSelectedItems.value }]),
                disabled: !hasSelectedItems.value,
                onClick: deleteSelectedItems
              }, " 删除 ", 10, _hoisted_34)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "player-dock" }, {
      default: _withCtx(() => [
        (currentAudioItem.value)
          ? (_openBlock(), _createElementBlock("section", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "history-audio-player-label" }, "正在播放", -1)),
                _createElementVNode("strong", _hoisted_37, _toDisplayString(currentAudioItem.value.title), 1)
              ]),
              _createElementVNode("audio", {
                ref_key: "audioPlayerRef",
                ref: audioPlayerRef,
                class: "history-audio-player",
                src: currentAudioSrc.value,
                controls: "",
                preload: "metadata",
                onEnded: handleAudioEnded
              }, null, 40, _hoisted_38)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(ParentPasswordModal, {
      ref_key: "parentPasswordModalRef",
      ref: parentPasswordModalRef
    }, null, 512)
  ], 2))
}
}

})